import React, { useMemo } from 'react';
import { Alert, AlertTitle, Box, Collapse } from '@availity/element';

import { useAppContext } from '@/context';

const MessageDisplay = () => {
  const { messages, removeMessage } = useAppContext();

  const showMessageDisplay = useMemo(() => messages?.length > 0, [messages]);

  const allMessages = useMemo(() => {
    let output;

    if (messages?.length > 0) {
      output = messages.map((message) => {
        const { dismissible, id, type, title, text } = message;
        if (!message) {
          return null;
        }

        const toggle = dismissible && (() => removeMessage(message.id));

        let color = type;
        if (type === 'danger') {
          color = 'error';
        }

        return (
          <Alert
            key={id}
            onClose={toggle}
            severity={color}
            sx={{
              padding: 1,
              marginBottom: 1,
            }}
          >
            {title && <AlertTitle>{title}</AlertTitle>}
            <Box
              display="flex"
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {text}
            </Box>
          </Alert>
        );
      });
    }

    return output;
  }, [messages]);

  return (
    <Collapse in={showMessageDisplay}>
      <Box mb={2}>{allMessages}</Box>
    </Collapse>
  );
};

export default MessageDisplay;
